import { QueryKey, UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

export function useAxiosQuery<T>(
  options: Omit<
  UndefinedInitialDataOptions<AxiosResponse<T>, Error, unknown, QueryKey>,
  'select'
  >,
) {
  return useQuery({
    ...options,
    select: (response) => response.data,
  })
}
